import familyPsychotherapyQuestionSet from "../faq/familyPsychotherapy/allQuestions";

export const psychoterapyFamily = {
    'meta': {
        'title': 'Terapia rodzinna #cityLocativeIn# • Centrum Psychoterapii COLLIGO',
        'description': 'Terapia rodzinna #cityLocativeIn#. Doświadczeni, psychoterapeuci pomogą Wam pokonać trudności, które napotykacie na codzień w funkcjonowaniu Waszej rodziny.'
    },
    'availability': [
        'torun',
        'bydgoszcz'
    ],
    'price': {
        'torun': {
            'first': 300,
            'next': 300
        },
        'bydgoszcz': {
            'first': 290,
            'next': 290
        }
    },
    'url': {
        'address': '#cityIdUrl#/uslugi/terapia-rodzinna/',
        'title': 'Terapia rodzinna #cityLocativeIn#',
        'name': 'Terapia rodzinna #cityLocativeIn#',
        'heading': 'Terapia rodzinna #cityLocativeIn#',
        'fullName': 'Terapia rodzinna'
    },
    'image': {
        'url': '/images/services/psychoterapia-rodzinna-w-toruniu.webp',
        'width': 886,
        'height': 295,
        'alt': 'Terapia rodzin #cityLocativeIn#'
    },
    'opengraph': {
        'image': {
            'url': '/images/services/open-graph/psychoterapia-rodzinna-w-toruniu.jpg',
            'width': 886,
            'height': 295,
            'alt': 'Psychoterapia rodzinna Toruń'
        }
    },
    'faq': familyPsychotherapyQuestionSet
}